"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermittableFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var PermittableFactory = /** @class */ (function (_super) {
    __extends(PermittableFactory, _super);
    function PermittableFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PermittableFactory.prototype.deploy = function (name, version, overrides) {
        return _super.prototype.deploy.call(this, name, version, overrides || {});
    };
    PermittableFactory.prototype.getDeployTransaction = function (name, version, overrides) {
        return _super.prototype.getDeployTransaction.call(this, name, version, overrides || {});
    };
    PermittableFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PermittableFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PermittableFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return PermittableFactory;
}(contracts_1.ContractFactory));
exports.PermittableFactory = PermittableFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "version",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506040516102d33803806102d383398101604081905261002f9161014e565b8151602092830120815191830191909120604080517f8b73c3c69bb8fe3d512ecc4cf759cc79239f7b179b0ffacaa9a75d522b39400f818601528082019390935260608301919091524660808301523060a0808401919091528151808403909101815260c0909201905280519101206000556101c4565b600082601f8301126100b6578081fd5b81516001600160401b03808211156100d0576100d06101ae565b604051601f8301601f19908116603f011681019082821181831017156100f8576100f86101ae565b81604052838152602092508683858801011115610113578485fd5b8491505b838210156101345785820183015181830184015290820190610117565b8382111561014457848385830101525b9695505050505050565b60008060408385031215610160578182fd5b82516001600160401b0380821115610176578384fd5b610182868387016100a6565b93506020850151915080821115610197578283fd5b506101a4858286016100a6565b9150509250929050565b634e487b7160e01b600052604160045260246000fd5b610100806101d36000396000f3fe6080604052348015600f57600080fd5b5060043610603c5760003560e01c806330adf81f1460415780633644e5151460795780637ecebe00146081575b600080fd5b60677f6e71edae12b1b97f4d1f60370fef10105fa2faae0126114a169c64845d6126c981565b60405190815260200160405180910390f35b606760005481565b6067608c366004609e565b60016020526000908152604090205481565b60006020828403121560ae578081fd5b81356001600160a01b038116811460c3578182fd5b939250505056fea26469706673582212203af4df5d07e6a45d4677ee45784a1a9dc4f7a61f5bb3668e98ceacd492c091e264736f6c63430008040033";
